import axios from 'axios';
import { toast } from 'react-toastify';

const baseURL = process.env.REACT_APP_INSURANCE_API_URL;
const authToken = process.env.REACT_APP_API_TOKEN;

const insuranceApi = axios.create({
    baseURL: baseURL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        Authorization: authToken,
    },
});

const responseHandler = (response) => {
    // Handle responses
    return response;
};

const errorHandler = (error) => {
    switch (error.response.status) {
        case 404:
            toast.error(
                'The data you are trying to reach is temporary unavailable',
            );
            break;
        case 500:
            toast.error(error.response.data.message);
            break;
        default:
            toast.error(error?.response?.data?.message || error.message);
            break;
    }
    return Promise.reject(error);
};

insuranceApi.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error),
);

export default insuranceApi;
